import React, { useEffect, useState } from 'react';
import { SpecialOfferProps } from '../types';
import { StyledPlaySimpleSpecialOffer } from './style';
import { Box } from '@mui/system';
import {
  EBadgePosition,
  EBadgeType,
  EBundlesInternalViewModel,
} from 'utils/enums';
import { BundlePrice } from 'components/BundlePrice';
import { PlaySimpleSaleBadge } from 'components/Badge/Sale/PlaySimpleSaleBadge';
import { MainProduct } from '../../Bundles/PlaySimple/MainProduct/MainProduct';
import { SubProduct } from '../../Bundles/PlaySimple/SubProduct/SubProduct';
import { checkIfOlderOsVersions } from 'utils';
import { BadgeData, IRibbonBadge } from 'components/Badge/types';
import { RibbonBadge } from 'components/Badge/RibbonBadge/RibbonBadge';
import { useGetBadge } from 'utils/useGetBadge';

export const PlaySimpleSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  collectText,
  availabilityText,
  availability,
  timer,
  badges = [],
  ribbonBadges = [],
}) => {
  const [isOldOS, setIsOldOS] = useState(false);
  // TODO remove old badge
  const [ribbonBadgeOld, setRibbonBadgeOld] = useState<any>(null);
  const ribbonBadgeNew = useGetBadge<IRibbonBadge>(ribbonBadges);

  useEffect(() => {
    if (badges.length > 0) {
      const foundRibbon = badges.find((badge: BadgeData) => {
        const badgeType = badge.badge ? badge.badge.type : badge.type;
        return badgeType === EBadgeType.RIBBON;
      });

      setRibbonBadgeOld(foundRibbon?.badge?.ribbon || foundRibbon?.ribbon);
    }
  }, [badges]);

  const ribbonBadge = ribbonBadgeNew ?? ribbonBadgeOld;

  useEffect(() => {
    if (checkIfOlderOsVersions()) {
      setIsOldOS(true);
    }
  }, []);

  return (
    <StyledPlaySimpleSpecialOffer
      onClick={selectOffer}
      backgroundImage={backgroundImage}
      productsHeight={availabilityText && availability}
      ribbonBadgeColor={
        ribbonBadge ? ribbonBadge.backgroundColor : { colorOne: '#8B34C3' }
      }
      data-testid={dataTestId}
    >
      <div className="container">
        {salePercentage > 0 && (
          <PlaySimpleSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
          />
        )}
        {productsList.length > 0 && (
          <Box className="products">
            <Box className="products-items">
              <MainProduct
                productImage={productsList[0].images.productPrefix}
                textColor={productsList[0].textFontColorHex}
                quantityDisplay={productsList[0].quantityDisplay}
                strokedSaleQuantity={productsList[0].strokedSaleQuantity}
                salePercentage={salePercentage}
              />
              {productsList.length > 1 && (
                <Box
                  className={`products-items--sub ${
                    isOldOS ? 'products-items--sub__ios13' : ''
                  }`}
                >
                  {productsList.slice(1, 5).map((product, i) => (
                    <SubProduct
                      productImage={product.images.product}
                      textColor={product.textFontColorHex}
                      quantityDisplay={product.quantityDisplay}
                      isOldOS={isOldOS}
                    />
                  ))}
                </Box>
              )}
              {availabilityText && availability && (
                <Box className="availability">
                  {availabilityText} {availability.remaining}/
                  {availability.total}
                </Box>
              )}
            </Box>
            <Box className="products--main-image">
              <img
                className="image"
                src={productsList[0].images.product}
                alt="main-product"
              />
            </Box>
          </Box>
        )}
        <BundlePrice
          prices={prices}
          type={EBundlesInternalViewModel.PLAY_SIMPLE}
          isFree={isFree}
          buttonText={collectText}
        />
        {timer && <Box className="timer">Ends in {timer}</Box>}
      </div>
      {ribbonBadge && (
        <>
          <RibbonBadge
            {...ribbonBadge}
            position={EBadgePosition.CENTER}
            viewModel={EBundlesInternalViewModel.PLAY_SIMPLE}
          />
          <Box className="ribbonBadge-arrow"></Box>
        </>
      )}
    </StyledPlaySimpleSpecialOffer>
  );
};
